import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaArrowLeft, FaSave } from 'react-icons/fa';
import { createArea } from '../../../models/areasModel';

function AreaCreate() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    area_name: '',
    sub_areas: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.area_name.trim()) {
      alert('Area name is required');
      return;
    }

    try {
      setLoading(true);
      const response = await createArea(formData);
      
      if (response.status === 1) {
        alert('Area created successfully!');
        navigate('/dashboard/areas');
      } else {
        alert(response.message || 'Failed to create area');
      }
    } catch (error) {
      console.error('Error creating area:', error);
      alert('Error creating area');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="mb-6 flex items-center">
        <Link
          to="/dashboard/areas"
          className="mr-4 text-gray-600 hover:text-gray-800"
        >
          <FaArrowLeft size={20} />
        </Link>
        <h1 className="text-2xl font-semibold text-gray-800">Create New Area</h1>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="area_name" className="block text-sm font-medium text-gray-700 mb-2">
              Area Name *
            </label>
            <input
              type="text"
              id="area_name"
              name="area_name"
              value={formData.area_name}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter area name"
              required
            />
          </div>

          <div>
            <label htmlFor="sub_areas" className="block text-sm font-medium text-gray-700 mb-2">
              Sub-Areas
            </label>
            <textarea
              id="sub_areas"
              name="sub_areas"
              value={formData.sub_areas}
              onChange={handleChange}
              rows={4}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter sub-areas separated by commas (e.g., Sub Area 1, Sub Area 2, Sub Area 3)"
            />
            <p className="mt-1 text-sm text-gray-500">
              Enter multiple sub-areas separated by commas. Leave empty if no sub-areas needed.
            </p>
          </div>

          <div className="flex justify-end space-x-4">
            <Link
              to="/dashboard/areas"
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              Cancel
            </Link>
            <button
              type="submit"
              disabled={loading}
              className={`px-4 py-2 rounded-md text-white flex items-center ${
                loading
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-blue-500 hover:bg-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
              }`}
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Creating...
                </>
              ) : (
                <>
                  <FaSave className="mr-2" />
                  Create Area
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AreaCreate;
